var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "WarehouseMovement" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "MovementNumber",
                        error: _vm.$v.form.MovementNumber,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled:
                            _vm.insertReadonly.MovementNumber || _vm.isItemAdded
                        },
                        model: {
                          value: _vm.form.MovementNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "MovementNumber", $$v)
                          },
                          expression: "form.MovementNumber"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "MovementDate",
                        error: _vm.$v.form.MovementDate,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextDatePicker", {
                        attrs: { disabled: _vm.insertReadonly.MovementDate },
                        model: {
                          value: _vm.form.MovementDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "MovementDate", $$v)
                          },
                          expression: "form.MovementDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "MovementTime",
                        error: _vm.$v.form.MovementTime,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextTimePicker", {
                        attrs: { disabled: _vm.insertReadonly.MovementTime },
                        model: {
                          value: _vm.form.MovementTime,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "MovementTime", $$v)
                          },
                          expression: "form.MovementTime"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "RepresentativeId",
                        error: _vm.$v.form.RepresentativeId,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          url:
                            "VisionNextEmployee/api/Employee/AutoCompleteSearch",
                          searchable: "",
                          orConditionFields: "Code,Description1,Name,Surname",
                          "dynamic-and-condition": { StatusIds: [1] },
                          disabled:
                            _vm.isItemAdded ||
                            _vm.insertReadonly.RepresentativeId
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedSearchType(
                              "RepresentativeId",
                              $event
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "MovementTypeId",
                        error: _vm.$v.form.MovementTypeId,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          url:
                            "VisionNextWarehouse/api/WarehouseMovementType/Search",
                          filter: function(item) {
                            return _vm.filteredMovementTypes.includes(item.Code)
                          },
                          "dynamic-and-condition": { StatusIds: [1] },
                          disabled:
                            _vm.isItemAdded || _vm.insertReadonly.MovementTypeId
                        },
                        on: {
                          input: function($event) {
                            _vm.selectedSearchType("MovementTypeId", $event)
                            _vm.selectStockStatus($event)
                          }
                        },
                        model: {
                          value: _vm.movementType,
                          callback: function($$v) {
                            _vm.movementType = $$v
                          },
                          expression: "movementType"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId,
                        md: "2",
                        lg: "2"
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          type: "number",
                          toggle: "",
                          disabled:
                            _vm.isItemAdded || _vm.insertReadonly.StatusId
                        },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.BranchStockTransfer.Items"),
                    active: ""
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RouteId",
                            error: _vm.$v.form.RouteId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextRoute/api/Route/Search",
                              "dynamic-and-condition": { StatusIds: [1] },
                              disabled:
                                (_vm.movementType &&
                                  (_vm.movementType.Code === "10" ||
                                    _vm.movementType.Code === "04" ||
                                    _vm.movementType.Code === "05")) ||
                                _vm.isItemAdded ||
                                _vm.insertReadonly.RouteId,
                              "order-by-columns": [
                                { Column: "Description1", OrderByType: 0 }
                              ],
                              "page-count": 500
                            },
                            on: { input: _vm.selectRoute },
                            model: {
                              value: _vm.route,
                              callback: function($$v) {
                                _vm.route = $$v
                              },
                              expression: "route"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !(
                        _vm.movementType &&
                        (_vm.movementType.Code === "05" ||
                          _vm.movementType.Code === "01" ||
                          _vm.movementType.Code === "07" ||
                          _vm.movementType.Code === "12")
                      )
                        ? _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                "item-key": "FromWarehouseId",
                                error: _vm.$v.form.FromWarehouseId,
                                md: "3",
                                lg: "3"
                              }
                            },
                            [
                              _c("NextDropdown", {
                                attrs: {
                                  source: _vm.fromWarehousesAll,
                                  disabled:
                                    (_vm.movementType &&
                                      _vm.movementType.Code === "04") ||
                                    _vm.movementType === null ||
                                    _vm.isItemAdded ||
                                    _vm.insertReadonly.FromWarehouseId
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.selectFromWarehouse($event)
                                  }
                                },
                                model: {
                                  value: _vm.fromWarehouse,
                                  callback: function($$v) {
                                    _vm.fromWarehouse = $$v
                                  },
                                  expression: "fromWarehouse"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.movementType &&
                      (_vm.movementType.Code === "05" ||
                        _vm.movementType.Code === "01" ||
                        _vm.movementType.Code === "07" ||
                        _vm.movementType.Code === "12")
                        ? _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                "item-key": "FromWarehouseId",
                                error: _vm.$v.form.FromWarehouseId,
                                md: "3",
                                lg: "3"
                              }
                            },
                            [
                              _c("NextDropdown", {
                                attrs: {
                                  source: _vm.fromWarehouses,
                                  disabled:
                                    (_vm.movementType &&
                                      _vm.movementType.Code === "04") ||
                                    _vm.movementType === null ||
                                    _vm.isItemAdded ||
                                    _vm.insertReadonly.FromWarehouseId
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.selectFromWarehouse($event)
                                  }
                                },
                                model: {
                                  value: _vm.fromWarehouse,
                                  callback: function($$v) {
                                    _vm.fromWarehouse = $$v
                                  },
                                  expression: "fromWarehouse"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "FromStatusId",
                            error: _vm.$v.form.FromStatusId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "dynamic-and-condition": { StatusIds: [1] },
                              url:
                                "VisionNextStockManagement/api/StockStatus/Search?v=1",
                              disabled:
                                (_vm.movementType &&
                                  _vm.movementType.Code === "04") ||
                                _vm.movementType === null ||
                                _vm.isItemAdded ||
                                _vm.disabledStatus ||
                                _vm.insertReadonly.FromStatusId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectFromStatus($event)
                              },
                              "all-source": _vm.setStockStatus
                            },
                            model: {
                              value: _vm.fromStatus,
                              callback: function($$v) {
                                _vm.fromStatus = $$v
                              },
                              expression: "fromStatus"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "VehicleId",
                            error: _vm.$v.form.VehicleId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "dynamic-and-condition": { StatusIds: [1] },
                              "page-count": 1000,
                              url: "VisionNextVehicle/api/Vehicle/Search",
                              disabled:
                                (_vm.movementType &&
                                  (_vm.movementType.Code === "10" ||
                                    _vm.movementType.Code === "04" ||
                                    _vm.movementType.Code === "05")) ||
                                _vm.isItemAdded ||
                                _vm.insertReadonly.VehicleId
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "VehicleId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.selectedVehicle,
                              callback: function($$v) {
                                _vm.selectedVehicle = $$v
                              },
                              expression: "selectedVehicle"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !(
                        _vm.movementType &&
                        (_vm.movementType.Code === "01" ||
                          _vm.movementType.Code === "07" ||
                          _vm.movementType.Code === "04")
                      )
                        ? _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                "item-key": "ToWarehouseId",
                                error: _vm.$v.form.ToWarehouseId,
                                md: "3",
                                lg: "3"
                              }
                            },
                            [
                              _c("NextDropdown", {
                                attrs: {
                                  source: _vm.fromWarehousesAll,
                                  disabled:
                                    (_vm.movementType &&
                                      _vm.movementType.Code === "05") ||
                                    _vm.movementType === null ||
                                    _vm.isItemAdded ||
                                    _vm.insertReadonly.ToWarehouseId
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.selectToWarehouse($event)
                                  }
                                },
                                model: {
                                  value: _vm.toWarehouse,
                                  callback: function($$v) {
                                    _vm.toWarehouse = $$v
                                  },
                                  expression: "toWarehouse"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.movementType &&
                      (_vm.movementType.Code === "01" ||
                        _vm.movementType.Code === "07" ||
                        _vm.movementType.Code === "04")
                        ? _c(
                            "NextFormGroup",
                            {
                              attrs: {
                                "item-key": "ToWarehouseId",
                                error: _vm.$v.form.ToWarehouseId,
                                md: "3",
                                lg: "3"
                              }
                            },
                            [
                              _c("NextDropdown", {
                                attrs: {
                                  source: _vm.toWarehouses,
                                  "dynamic-and-condition":
                                    { StatusIds: [1] } &&
                                    _vm.getToWarehouseAndCondition(),
                                  disabled:
                                    (_vm.movementType &&
                                      _vm.movementType.Code === "05") ||
                                    _vm.movementType === null ||
                                    _vm.isItemAdded ||
                                    _vm.insertReadonly.ToWarehouseId
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.selectToWarehouse($event)
                                  }
                                },
                                model: {
                                  value: _vm.toWarehouse,
                                  callback: function($$v) {
                                    _vm.toWarehouse = $$v
                                  },
                                  expression: "toWarehouse"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ToStatusId",
                            error: _vm.$v.form.ToStatusId,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "dynamic-and-condition": { StatusIds: [1] },
                              url:
                                "VisionNextStockManagement/api/StockStatus/Search?v=2",
                              disabled:
                                (_vm.movementType &&
                                  (_vm.movementType.Code === "05" ||
                                    _vm.movementType.Code === "01" ||
                                    _vm.movementType.Code === "10")) ||
                                _vm.movementType === null ||
                                _vm.isItemAdded ||
                                _vm.disabledStatus
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "ToStatusId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.toStatus,
                              callback: function($$v) {
                                _vm.toStatus = $$v
                              },
                              expression: "toStatus"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.BranchStockTransfer.ItemCode"
                            ),
                            required: true,
                            error: _vm.$v.warehouseMovementItems.item,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              searchable: "",
                              search: _vm.searchItem,
                              "custom-option": true
                            },
                            on: { input: _vm.selectedItem },
                            model: {
                              value: _vm.warehouseMovementItems.item,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.warehouseMovementItems,
                                  "item",
                                  $$v
                                )
                              },
                              expression: "warehouseMovementItems.item"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.BranchStockTransfer.FromWhStockQuantity"
                            ),
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "number", disabled: true },
                            model: {
                              value:
                                _vm.warehouseMovementItems.fromWhStockQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.warehouseMovementItems,
                                  "fromWhStockQuantity",
                                  $$v
                                )
                              },
                              expression:
                                "warehouseMovementItems.fromWhStockQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.BranchStockTransfer.ToWhStockQuantity"
                            ),
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "number", disabled: true },
                            model: {
                              value:
                                _vm.warehouseMovementItems.toWhStockQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.warehouseMovementItems,
                                  "toWhStockQuantity",
                                  $$v
                                )
                              },
                              expression:
                                "warehouseMovementItems.toWhStockQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.BranchStockTransfer.PlanQuantity"
                            ),
                            required: true,
                            error: _vm.$v.warehouseMovementItems.quantity,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          this.UnitId === 1526
                            ? _c("NextInput", {
                                attrs: { type: "text" },
                                on: {
                                  keypress: function($event) {
                                    return _vm.onlyForNumber($event)
                                  }
                                },
                                model: {
                                  value: _vm.warehouseMovementItems.quantity,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.warehouseMovementItems,
                                      "quantity",
                                      $$v
                                    )
                                  },
                                  expression: "warehouseMovementItems.quantity"
                                }
                              })
                            : _c("NextInput", {
                                attrs: { type: "text" },
                                on: {
                                  keypress: function($event) {
                                    return _vm.onlyForCurrencyDotOrComma($event)
                                  }
                                },
                                model: {
                                  value: _vm.warehouseMovementItems.quantity,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.warehouseMovementItems,
                                      "quantity",
                                      $$v
                                    )
                                  },
                                  expression: "warehouseMovementItems.quantity"
                                }
                              })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "ml-auto",
                          attrs: { cols: "12", md: "3", lg: "3" }
                        },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("AddDetailButton", {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.addItem()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "2" } },
                        [
                          _c("NextMultipleSelection", {
                            attrs: {
                              name: "WarehouseMovementMultipleItem",
                              "disabled-button": _vm.disabledMultipleSelection,
                              "hidden-values": _vm.multipleHiddenValues,
                              validations: _vm.multipleValidations,
                              "dynamic-and-condition": {
                                FromWarehouseIds: _vm.form.FromWarehouseId
                                  ? [_vm.form.FromWarehouseId]
                                  : null,
                                ToWarehouseIds: _vm.form.ToWarehouseId
                                  ? [_vm.form.ToWarehouseId]
                                  : null,
                                MovementType: [_vm.form.MovementTypeId],
                                FromWarehouseStatus: _vm.form.FromStatusId
                                  ? [_vm.form.FromStatusId]
                                  : null,
                                ToWarehouseStatus: _vm.form.ToStatusId
                                  ? [_vm.form.ToStatusId]
                                  : null
                              },
                              "filter-func": function(row) {
                                return row.Quantity > 0
                              }
                            },
                            model: {
                              value: _vm.form.WarehouseMovementItems,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "WarehouseMovementItems",
                                  $$v
                                )
                              },
                              expression: "form.WarehouseMovementItems"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-table-simple",
                            {
                              attrs: { responsive: "", bordered: "", small: "" }
                            },
                            [
                              _c(
                                "b-thead",
                                [
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.BranchStockTransfer.ItemCode"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.BranchStockTransfer.Items"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.BranchStockTransfer.FromWhStockQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.BranchStockTransfer.ToWhStockQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "insert.BranchStockTransfer.PlanQuantity"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("list.operations")))
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tbody",
                                _vm._l(
                                  _vm.form.WarehouseMovementItems,
                                  function(r, i) {
                                    return _c(
                                      "b-tr",
                                      { key: i },
                                      [
                                        _c("b-td", [_vm._v(_vm._s(r.Code))]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.Description1))
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.FromWhStockQuantity))
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(_vm._s(r.ToWhStockQuantity))
                                        ]),
                                        _vm._v(" "),
                                        _c("b-td", [
                                          _vm._v(
                                            _vm._s(_vm.formatValue(r.Quantity))
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "b-td",
                                          { staticClass: "text-center" },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                staticClass:
                                                  "btn mr-2 btn-warning btn-sm",
                                                attrs: {
                                                  title: _vm.$t("list.edit")
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.editItem(r)
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-pencil-alt"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-button",
                                              {
                                                staticClass:
                                                  "btn mr-2 btn-danger btn-sm",
                                                attrs: {
                                                  title: _vm.$t("list.delete"),
                                                  type: "button"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeItem(r)
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "far fa-trash-alt ml-1"
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24f1970c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24f1970c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/WarehouseMovement/insert.vue
// module id = null
// module chunks = 